import cn from 'clsx';
import React, { useEffect, useState } from 'react';
import { logger } from 'src/services/logger/loggerService';
import s from 'src/shared/styles/ui/Progress/Progress.module.css';

export interface ProgressProps {
  progress: number; // o-100
}

const Progress: React.FC<ProgressProps> = (props) => {
  const { progress } = props;
  const rootClassName = cn(s.root, {});
  const [_progress, setProgress] = useState(0);
  useEffect(() => {
    if (isNaN(progress)) {
      logger.error('Progress is not integer', progress);
    } else if (progress < 0 || progress > 100) {
      logger.error('Progress is between 0-100', progress);
    }
    setTimeout(() => {
      setProgress(progress);
    }, 100);
  }, [progress]);
  return (
    <div className={rootClassName}>
      <div className={s.progressClassName} style={{ width: `${_progress}%` }}></div>
    </div>
  );
};

export default React.memo(Progress);
